import { em } from 'polished'
import styled from 'styled-components'

import { PriceMedium } from 'styles/components/typography'

export const CrossedCostBlock = styled.div`
  position: relative;
  line-height: 0;
  white-space: nowrap;
  margin-top: -${em(3)};
`

export const MutedCostBox = styled.span`
  opacity: 0.2;

  & ${PriceMedium} {
    font-family: ${p => p.theme.typography.baseFont};

    ${p => p.theme.mq.upMd} {
      font-family: ${p => p.theme.typography.baseFont};
    }
  }
`

export const CostBlock = styled.div`
  display: block;
  line-height: 0;
`

export const PriceWrapper = styled.div`
  ${p =>
    p.inRow &&
    `
    display: flex;

    ${CrossedCostBlock} {
      margin-top: 0;
      margin-left: ${em(14)};
    }
  `}

  ${p => p.theme.mq.upMd} {
    margin-top: -${em(10)};
  }

  ${p => p.theme.mq.upLg} {
    margin-top: 0;
  }
`
